import { Box, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import axios from "axios";
import useApiEp from "../../hooks/useApiEp";
import { getHeader, toastError } from "../../utils/util";
import { toast } from "react-toastify";
import { LoadingButton } from "@mui/lab";
import { API_ENDPOINT } from "../../utils/constants";

const LocationMessage = () => {
  const { data, isLoading, isError, error } = useApiEp(
    `/api/get-location-message`
  );
  const [locationMessage, setLocationMessage] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (data?.locationMessage) {
      setLocationMessage(data.locationMessage);
    }
  }, [data]);

  const handleSubmit = async () => {
    try {
      setSaving(true);
      const response = await axios.post(
        `${API_ENDPOINT}/api/save-location-message`,
        { locationMessage },
        getHeader()
      );

      toast.success(response.data.message);
    } catch (error) {
      toastError(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box sx={{ my: 2 }}>
      <TextField
        fullWidth
        label="Location Message"
        placeholder="Enter location message..."
        value={locationMessage}
        onChange={(e) => setLocationMessage(e.target.value)}
        multiline
        rows={3}
        helperText="This message to be sent to user who share location"
        sx={{ mb: 2 }}
      />

      <LoadingButton
        variant="contained"
        fullWidth
        loading={saving}
        onClick={handleSubmit}
      >
        Submit
      </LoadingButton>
    </Box>
  );
};

export default LocationMessage;
